<template>
	<div>
		<egranty-section-divider
			:small="readonly"
			:text="readonly ? 'Typ projektu' : 'Wybierz typ projektu'"
			icon="list"
		></egranty-section-divider>

		<v-select
			class="ma-3 ml-4"
			:disabled="readonly"
			:label="readonly? '' : 'Typ projektu'"
			:items="types"
			aria-label="project type"
			item-text="type"
			item-value="id"
			v-model="chosenTypeId"
			@input="sync"
		></v-select>
		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>
</template>

<script>
	import {AgencyContest} from "../../../../api/generated/AgencyContest";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";

	export default {
		name: "AgencyChooseProjectType",
		components: {EgrantyValidationError, EgrantySectionDivider},
		data() {
			return {
				types: [],
				chosenTypeId: "",
				error: ''
			};
		},

		methods: {
			sync() {
				this.$emit('input', this.chosenTypeId);
				this.error = '';
			},

			validate() {
				this.error = '';
				if (this.chosenTypeId === null) {
					this.error = 'Proszę wybrać typ projektu';
				}
				return this.error === '';
			}
		},

		props: {
			contestId: {},
			value: {},
			readonly: {
				type: Boolean,
				default: false
			}
		},

		watch: {
			value: {
				immediate: true,
				handler(value) {
					this.chosenTypeId = value;
				}
			}
		},

		mounted() {
			AgencyContest.getProjectTypes(
				this,
				this.contestId,
				response => this.types = response
			);
		}
	};
</script>

<style scoped>

</style>
